export const convertAnyToError = (error) => {
    const errorType = Object.prototype.toString.call(error);
    try {
        switch (errorType) {
            case '[object Error]':
                return error;
            case '[object String]':
                return new Error(error);
            default:
                return new Error(JSON.stringify(error));
        }
    }
    catch (err) {
        return err;
    }
};
//# sourceMappingURL=errorReporting.shared.js.map